<template>
  <div>
    <!--    First Version Caspian-->
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row v-if="getMobileLayout">
        <b-col cols="12">
          <HeaderNewVersion />
        </b-col>
        <b-col cols="12">
          <!--        First Container for (Tether) Notice-->
          <transition
            name="animate__fadeIn"
            enter-active-class="animate__animated animate__fadeIn"
            appear
          >
            <b-container v-if="getStepperPage === 'pageOne'" class="my-1 py-1">
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col
                  v-for="(account, index) in offlineAccountList"
                  :key="index"
                  cols="4"
                  class="d-flex justify-content-center align-items-center"
                >
                  <button
                    class="d-flex flex-column background-transparent border-none align-items-center justify-content-center"
                    @click="selectAccount(account, 'pageTwo')"
                  >
                    <img
                      class="ordinary-img"
                      :src="handleOfflineAccountBankLogo(account)"
                      :class="{
                        'mix-blend-mode-luminosity': false,
                      }"
                      height="80"
                      width="80"
                    />
                    <p class="mt-2 font-size-medium-small font-weight-bold">
                      {{ handleOfflineAccountBankName(account) }}
                    </p>
                  </button>
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex justify-content-center align-items-center mt-5 pt-5"
                >
                  <span
                    class="cornflower-blue-text font-size-large font-weight-bold text-center"
                  >
                    {{ $translate("cardToCardBankSelect") }}
                  </span>
                </b-col>
                <!-- <b-col
                  cols="4"
                  class="d-flex justify-content-center align-items-center pt-3"
                >
                  <button
                    class="new-version-decline-button"
                    @click="goPageBack()"
                  >
                    {{ $translate("back") }}
                  </button>
                </b-col> -->
                <b-col
                  cols="4"
                  class="d-flex justify-content-center align-items-center pt-3"
                >
                  <button
                    type="button"
                    class="new-version-decline-button"
                    @click="cancelPayment"
                  >
                    <span class="button-texts">
                      {{ $translate("cancel") }}
                    </span>
                  </button>
                </b-col>
              </b-row>
            </b-container>
          </transition>

          <transition
            name="animate__fadeIn"
            enter-active-class="animate__animated animate__fadeIn"
            appear
          >
            <b-container v-if="getStepperPage === 'pageTwo'" class="my-1 py-1">
              <b-col
                class="d-flex justify-content-center align-items-center alert-text font-size-large pb-2"
              >
                <!--                TODO: use the web fonts.-->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="19"
                  fill="currentColor"
                  class="bi bi-exclamation-triangle font-weight-bold"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"
                  />
                  <path
                    d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"
                  />
                </svg>
                <span class="font-weight-bold mr-1">{{
                  $translate("attention")
                }}</span>
              </b-col>
              <b-col class="new-title-color font-size-medium pb-2">
                <p>
                  {{ $translate("pleaseKeepInMindThereIsAChanceOf") }}
                  <span class="red-text font-weight-bold">
                    {{ $translate("change") }}
                  </span>
                  {{
                    $translate(
                      "theDestinationCardNumberPleaseCheckThisPageBeforeEachDeposit"
                    )
                  }}
                </p>
              </b-col>
              <!--          75% Padding is for making this page's height as equal as shetabs-->
              <b-col class="new-title-color font-size-medium">
                <p>
                  {{
                    $translate(
                      "otherwiseIfYouDepositToTheOldCardNumberYourAccountCouldNotBeCharged"
                    )
                  }}
                </p>
              </b-col>
              <b-col class="new-title-color font-size-medium pb-2">
                <p
                  v-html="
                    $translate(
                      'andAfterPaymentWait5MinutesAndEnterYourCardNumber'
                    )
                  "
                ></p>
              </b-col>
              <b-col class="flex-center pb-3" @click="openVideoPlayer()">
                <button
                  type="button"
                  class="font-weight-bold border-none background-transparent"
                >
                  <span class="steel-blue-text button-texts">
                    {{ $translate("helper") }}
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-info-circle steel-blue-text"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                    />
                  </svg>
                </button>
              </b-col>
              <b-col class="flex-center pb-2">
                <button
                  type="button"
                  class="go-to-next-button"
                  @click="getCardNumber()"
                >
                  <b-row class="fill-width">
                    <b-col cols="10"
                      ><span class="button-texts">
                        {{ $translate("showCard") }}</span
                      ></b-col
                    >
                    <b-col cols="2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        class="bi bi-arrow-left-short"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                        />
                      </svg>
                    </b-col>
                  </b-row>
                </button>
              </b-col>
            </b-container>
          </transition>
          <!--        /First Container for (CardToCard) Notice-->

          <!--        Second Container for (CardToCard) Show Wallet and Payment Information-->

          <b-col
            class="steel-blue-text font-size-medium flex-center"
            v-if="getStepperPage === 'pageThree'"
          >
            <span class="mb-0 new-title-color font-weight-bold">
              {{ $translate("enterAmountAndYourCardNumber") }}
            </span>
          </b-col>
          <transition
            name="animate__fadeIn"
            enter-active-class="animate__animated animate__fadeIn"
            appear
          >
            <b-container v-if="getStepperPage === 'pageThree'" class="my-3">
              <b-col class="flex-center new-title-color pb-3">
                <img
                  :src="handleCardImage(selectedAccount)"
                  class="fill-width position-relative"
                />
                <div class="image-card-details">
                  <b-row no-gutters class="flex-center">
                    <b-col
                      cols="12"
                      class="flex-center direction-ltr font-size-xl pt-2"
                    >
                      {{ receiverCreditCardNumber | creditCardSep }}
                    </b-col>
                    <b-col
                      cols="9"
                      class="pt-1 d-flex justify-content-start align-items-center card-owner-name-text"
                    >
                      {{ receiverName }}
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-row class="d-flex align-items-center mb-3">
                <b-col
                  cols="7"
                  class="new-title-color font-size-small pb-1 font-weight-bold"
                >
                  <span> {{ $translate("cardNumber") }}: </span>
                </b-col>
                <!--                read only input-->
                <b-row
                  no-gutters
                  class="direction-ltr m-0 p-0"
                  v-if="isCreditCardReceivedFromServer"
                >
                  <b-col cols="12">
                    <div class="input-group p-0">
                      <div class="input-group-prepend" v-if="bankImageSource">
                        <span class="input-group-text fill-height border-none">
                          <img
                            :src="bankImageSource"
                            height="25"
                            width="25"
                            v-if="checkIfInputNotEmpty"
                          />
                        </span>
                      </div>
                      <input
                        v-for="(key, i) in creditCardInfo"
                        :value="creditCardInfo[i].value"
                        :key="i"
                        readonly
                        class="col-2 form-control new-form-control mx-1"
                      />
                    </div>
                  </b-col>
                </b-row>
                <b-row
                  no-gutters
                  class="direction-ltr m-0 p-0"
                  v-if="!isCreditCardReceivedFromServer"
                >
                  <b-col cols="12">
                    <div class="input-group p-0">
                      <div class="input-group-prepend" v-if="bankImageSource">
                        <span class="input-group-text fill-height">
                          <img
                            :src="bankImageSource"
                            height="25"
                            width="25"
                            v-if="checkIfInputNotEmpty"
                          />
                        </span>
                      </div>
                      <input
                        v-for="(key, i) in creditCardInfo"
                        required
                        @paste="onCreditCardPaste($event, 'creditCardInfo')"
                        @input="handleAutoFocus(i)"
                        :id="`credit-card-input-key${i}`"
                        :key="i"
                        v-model="key.value"
                        class="col-2 form-control new-form-control mx-1"
                        placeholder="0000"
                        v-mask="'####'"
                        mask="false"
                      />
                    </div>
                  </b-col>
                  <transition
                    name="animate__fadeIn"
                    :duration="200"
                    enter-active-class="animate__animated animate__fadeIn "
                    leave-active-class="animate__animated animate__fadeOut "
                    appear
                  >
                    <b-col
                      cols="12"
                      class="d-flex justify-content-end align-items-center pt-3"
                      v-if="
                        !secondContainerVisibility &&
                        creditCardInfo[3].value.length === 4
                      "
                    >
                      <span class="alert-text font-size-xs font-weight-bold">
                        {{ $translate("invalidCardNumber") }}
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-row>

              <b-row class="d-flex align-items-center">
                <b-col
                  cols="5"
                  class="new-title-color font-size-small pb-1 font-weight-bold"
                >
                  <span>
                    {{ $translate("payingAmount") }} ({{
                      $translate("toman")
                    }}):
                  </span>
                </b-col>
                <b-col
                  cols="7"
                  class="padding-left-20px"
                  v-if="
                    !isShetabAmountsReceivedFromServer && !shetabOfflineAmounts
                  "
                >
                  <input
                    :placeholder="$translate('enterThePayingAmount')"
                    class="form-control new-form-control mx-1 text-end"
                    v-mask="'###############'"
                    mask="false"
                    v-model="amountValue"
                  />
                </b-col>
                <b-col
                  cols="7"
                  class="padding-left-20px"
                  v-if="isShetabAmountsReceivedFromServer"
                >
                  <input
                    class="form-control new-form-control mx-1"
                    v-mask="'###############'"
                    mask="false"
                    readonly
                    v-model="amountValue"
                  />
                </b-col>
                <b-col
                  cols="7"
                  class="padding-left-20px"
                  v-if="
                    !isShetabAmountsReceivedFromServer && shetabOfflineAmounts
                  "
                >
                  <b-form-select
                    class="form-control new-form-control"
                    v-model="amountValue"
                    :options="shetabOfflineAmounts"
                    required
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row class="flex-vertical-align pt-4">
                <b-col cols="12" class="mb-2">
                  {{ $translate("securityCode") }}:</b-col
                >
                <b-col cols="12">
                  <b-input
                    :placeholder="
                      $translate('enterTheSecurityCodeInTheContainerBelow')
                    "
                    class="direction-ltr new-form-control"
                    id="captchaInput"
                    v-mask="'####'"
                    mask="false"
                    v-model="captchaInput"
                    :class="{ secondVersionInputs: getVersion === 'v2' }"
                  ></b-input>
                </b-col>
              </b-row>
              <b-container class="my-4">
                <b-row class="align-items-center justify-content-center">
                  <b-col align-self="center" cols="8">
                    <b-row
                      class="align-items-center justify-content-center captcha-row"
                    >
                      <b-col cols="10" class="d-flex justify-content-center">
                        <!--Captcha Image-->
                        <b-spinner
                          variant="primary"
                          v-if="getCaptchaImagePending"
                          class="mx-5 my-2"
                        ></b-spinner>
                        <b-img
                          width="150px"
                          :src="imageBase64"
                          v-if="!getCaptchaImagePending"
                        />
                        <!--Captcha Image-->
                      </b-col>
                      <b-col
                        cols="2"
                        class="cursor-pointer justify-content-center d-flex p-0 border-right-1px"
                        @click="getCaptchaImage"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="currentColor"
                          class="bi bi-arrow-clockwise"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                          />
                          <path
                            d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                          />
                        </svg>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>

              <b-row class="flex-center pb-4">
                <button
                  class="ctc-payment-button"
                  @click="submitBuyerCardInfo()"
                >
                  <span class="button-texts">
                    {{ $translate("checkPayment") }}
                  </span>
                </button>
              </b-row>
            </b-container>
          </transition>
          <!--        /Second Container for (Tether) Show Wallet and Payment Information-->
        </b-col>
      </b-row>
      <DesktopLayoutHelperNewVersion v-else-if="!getMobileLayout">
        <template v-slot:body>
          <b-container class="m-1 p-1">
            <b-row>
              <b-col
                cols="12"
                v-if="getStepperPage === 'pageOne'"
                class="px-0 d-flex justify-content-center"
                ><b-row
                  class="mt-3 fill-width d-flex justify-content-center align-items-center"
                >
                  <b-col
                    v-for="(account, index) in offlineAccountList"
                    :key="index"
                    cols="4"
                    class="d-flex justify-content-center align-items-center"
                  >
                    <button
                      class="d-flex flex-column background-transparent border-none align-items-center justify-content-center"
                      @click="selectAccount(account, 'pageTwo')"
                    >
                      <img
                        class="ordinary-img"
                        :src="handleOfflineAccountBankLogo(account)"
                        :class="{
                          'mix-blend-mode-luminosity': false,
                        }"
                        height="80"
                        width="80"
                      />
                      <p class="mt-2 font-size-medium-small font-weight-bold">
                        {{ handleOfflineAccountBankName(account) }}
                      </p>
                    </button>
                  </b-col>

                  <b-col
                    cols="12"
                    class="d-flex justify-content-center align-items-center mt-5 pt-5"
                  >
                    <span
                      class="cornflower-blue-text font-size-large font-weight-bold"
                    >
                      {{ $translate("cardToCardBankSelect") }}
                    </span>
                  </b-col>
                  <b-row class="d-flex justify-content-center mx-0 px-0">
                    <b-col
                      cols="4"
                      class="d-flex justify-content-center align-items-center mt-3"
                    >
                      <button
                        type="button"
                        class="new-version-decline-button"
                        @click="cancelPayment"
                      >
                        <span class="button-texts">
                          {{ $translate("cancel") }}
                        </span>
                      </button>
                    </b-col>
                  </b-row>
                </b-row>
              </b-col>

              <b-col cols="12" v-if="getStepperPage === 'pageTwo'">
                <b-row>
                  <b-col
                    cols="12"
                    class="d-flex justify-content-start align-items-center alert-text font-size-large pb-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="19"
                      fill="currentColor"
                      class="bi bi-exclamation-triangle font-weight-bold"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"
                      />
                      <path
                        d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"
                      />
                    </svg>
                    <span class="font-weight-bold mr-1">{{
                      $translate("attention")
                    }}</span>
                  </b-col>
                  <b-col
                    cols="12"
                    class="new-title-color font-size-medium pb-2"
                  >
                    <p
                      v-html="
                        $translate(
                          'pleaseKeepInMindThereIsAChanceOfCardNumberChange'
                        )
                      "
                    ></p>
                  </b-col>
                </b-row>
                <!--                button section-->
                <b-row>
                  <b-col cols="12">
                    <b-row>
                      <b-col cols="3">
                        <button
                          @click="openVideoPlayer()"
                          type="button"
                          class="font-weight-bold border-none background-transparent"
                        >
                          <span class="steel-blue-text button-texts">
                            {{ $translate("helper") }}
                          </span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-info-circle steel-blue-text"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                            />
                            <path
                              d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                            />
                          </svg>
                        </button>
                      </b-col>
                      <b-col cols="5"> </b-col>
                      <b-col cols="4" class="d-flex justify-content-end">
                        <button
                          type="button"
                          class="go-to-next-button"
                          @click="getCardNumber()"
                        >
                          <b-row class="fill-width">
                            <b-col cols="10"
                              ><span class="button-texts">
                                {{ $translate("showCard") }}</span
                              ></b-col
                            >
                            <b-col cols="2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="currentColor"
                                class="bi bi-arrow-left-short"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                                />
                              </svg>
                            </b-col>
                          </b-row>
                        </button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" v-if="getStepperPage === 'pageThree'">
                <b-row class="fill-width fill-height">
                  <b-col
                    cols="1"
                    class="d-flex flex-column justify-content-center align-items-center fill-height px-0"
                  >
                    <b-row class="rotate-270deg">
                      <b-col
                        cols="12"
                        class="d-flex justify-content-center align-items-center ctc-title-background"
                      >
                        <span
                          class="fill-width white-space-nowrap ctc-title-info-text pa-1"
                        >
                          {{ $translate("enterAmountAndYourCardNumber") }}
                        </span>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="7" lg="6" xl="6" md="5">
                    <b-row>
                      <b-col
                        cols="12"
                        class="new-title-color font-size-medium-small pb-1 font-weight-bold"
                      >
                        <span> {{ $translate("cardNumber") }}: </span>
                      </b-col>
                    </b-row>

                    <b-row
                      no-gutters
                      class="direction-ltr m-0 p-0"
                      v-if="isCreditCardReceivedFromServer"
                    >
                      <b-col cols="12">
                        <div class="input-group p-0">
                          <div
                            class="input-group-prepend"
                            v-if="bankImageSource"
                          >
                            <span
                              class="input-group-text fill-height border-none"
                            >
                              <img
                                :src="bankImageSource"
                                height="25"
                                width="25"
                                v-if="checkIfInputNotEmpty"
                              />
                            </span>
                          </div>
                          <input
                            v-for="(key, i) in creditCardInfo"
                            :value="creditCardInfo[i].value"
                            :key="i"
                            readonly
                            class="col-2 form-control new-form-control mx-1"
                          />
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      no-gutters
                      class="direction-ltr m-0 p-0"
                      v-if="!isCreditCardReceivedFromServer"
                    >
                      <b-col cols="12 px-0 mt-2">
                        <div class="input-group p-0">
                          <div
                            class="input-group-prepend"
                            v-if="bankImageSource"
                          >
                            <span class="input-group-text fill-height">
                              <img
                                :src="bankImageSource"
                                height="25"
                                width="25"
                                v-if="checkIfInputNotEmpty"
                              />
                            </span>
                          </div>
                          <input
                            v-for="(key, i) in creditCardInfo"
                            required
                            @paste="onCreditCardPaste($event, 'creditCardInfo')"
                            @input="handleAutoFocus(i)"
                            :id="`credit-card-input-key${i}`"
                            :key="i"
                            v-model="key.value"
                            class="col-2 form-control new-form-control mx-1"
                            placeholder="0000"
                            v-mask="'####'"
                            mask="false"
                          />
                        </div>
                      </b-col>
                      <transition
                        name="animate__fadeIn"
                        :duration="200"
                        enter-active-class="animate__animated animate__fadeIn "
                        leave-active-class="animate__animated animate__fadeOut "
                        appear
                      >
                        <b-col
                          cols="12"
                          class="d-flex justify-content-end align-items-center pt-3"
                          v-if="
                            !secondContainerVisibility &&
                            creditCardInfo[3].value.length === 4
                          "
                        >
                          <span
                            class="alert-text font-size-xs font-weight-bold"
                          >
                            {{ $translate("invalidCardNumber") }}
                          </span>
                        </b-col>
                      </transition>
                    </b-row>
                    <b-row class="d-flex align-items-center mt-3">
                      <b-col
                        cols="12"
                        class="new-title-color font-size-medium-small pb-1 font-weight-bold"
                      >
                        <span>
                          {{ $translate("payingAmount") }} ({{
                            $translate("toman")
                          }}):
                        </span>
                      </b-col>
                      <b-col
                        cols="12"
                        class="padding-left-20px"
                        v-if="
                          !isShetabAmountsReceivedFromServer &&
                          !shetabOfflineAmounts
                        "
                      >
                        <input
                          :placeholder="$translate('enterThePayingAmount')"
                          class="form-control new-form-control mx-1 text-end"
                          v-mask="'###############'"
                          mask="false"
                          v-model="amountValue"
                        />
                      </b-col>
                      <b-col
                        cols="7"
                        class="padding-left-20px"
                        v-if="isShetabAmountsReceivedFromServer"
                      >
                        <input
                          class="form-control new-form-control mx-1"
                          v-mask="'###############'"
                          mask="false"
                          readonly
                          v-model="amountValue"
                        />
                      </b-col>
                      <b-col
                        cols="7"
                        class="padding-left-20px"
                        v-if="
                          !isShetabAmountsReceivedFromServer &&
                          shetabOfflineAmounts
                        "
                      >
                        <b-form-select
                          class="form-control new-form-control"
                          v-model="amountValue"
                          :options="shetabOfflineAmounts"
                          required
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-col
                      cols="12"
                      class="new-title-color font-size-medium-small pb-1 font-weight-bold mt-3"
                    >
                      <span> {{ $translate("securityCode") }}: </span>
                    </b-col>
                    <b-col
                      cols="12"
                      class="d-flex justify-content-center align-items-center"
                    >
                      <b-row class="fill-width">
                        <b-col
                          cols="7"
                          class="d-flex justify-content-center align-items-center pr-0"
                        >
                          <b-input
                            :placeholder="
                              $translate(
                                'enterTheSecurityCodeInTheContainerBelow'
                              )
                            "
                            class="direction-ltr new-form-control text-end"
                            id="voucherNumber"
                            v-mask="'####'"
                            mask="false"
                            v-model="captchaInput"
                          ></b-input>
                        </b-col>
                        <b-col
                          cols="5"
                          class="d-flex justify-content-center align-items-center"
                        >
                          <b-row
                            class="d-flex justify-content-center align-items-center fill-width captcha-row"
                          >
                            <b-col
                              cols="10"
                              class="d-flex justify-content-center"
                            >
                              <!--Captcha Image-->
                              <b-spinner
                                variant="primary"
                                v-if="getCaptchaImagePending"
                                class="mx-5 my-2"
                              ></b-spinner>
                              <b-img
                                width="150px"
                                :src="imageBase64"
                                v-if="!getCaptchaImagePending"
                              />
                              <!--Captcha Image-->
                            </b-col>
                            <b-col
                              cols="2"
                              class="d-flex justify-content-center cursor-pointer border-right-1px p-0"
                              @click="getCaptchaImage"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="currentColor"
                                class="bi bi-arrow-clockwise"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                />
                                <path
                                  d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                                />
                              </svg>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                  <b-col cols="4" lg="5" xl="5" md="6">
                    <b-row>
                      <b-col cols="12" class="flex-center new-title-color">
                        <img
                          :src="handleCardImage(selectedAccount)"
                          class="fill-width position-relative"
                        />
                        <div class="image-card-details">
                          <b-row no-gutters class="flex-center">
                            <b-col
                              cols="12"
                              class="flex-center direction-ltr d-font-size"
                            >
                              {{ receiverCreditCardNumber | creditCardSep }}
                            </b-col>
                            <b-col
                              cols="9"
                              class="pt-1 d-flex justify-content-start align-items-center card-owner-name-text"
                            >
                              {{ receiverName }}
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        class="d-flex justify-content-center mt-2"
                      >
                        <button
                          class="ctc-payment-button fill-width"
                          @click="submitBuyerCardInfo()"
                        >
                          <span class="button-texts">
                            {{ $translate("checkPayment") }}
                          </span>
                        </button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </template>
      </DesktopLayoutHelperNewVersion>
    </transition>
    <!--    <VideoPlayer v-if="showVideo" @closeVideoClickedOutSide="clickedOutSideOfVideo" :videoAddress="videoAddress"/>-->
    <!--    /First Version Caspian-->
  </div>
</template>
<script>
import { cardToCardMixin } from "@/mixins/CardToCardMixin";
import HeaderNewVersion from "@/components/HeaderNewVersion";
import { mapGetters } from "vuex";
import DesktopLayoutHelperNewVersion from "@/components/DesktopLayoutHelperNewVersion";

export default {
  name: "CardToCardNewVersion",
  components: {
    DesktopLayoutHelperNewVersion,
    HeaderNewVersion,
    // VideoPlayer,
  },
  mixins: [cardToCardMixin],
  computed: {
    ...mapGetters(["getMobileLayout"]),
  },
};
</script>

<style scoped>
.captcha-row {
  border-radius: 10px;
  border: 2px solid #e7e7e7;
}
.ctc-title-info-text {
  color: #855ded;
  text-align: center;
  font-weight: 700;
  letter-spacing: -0.6px;
}
.ctc-title-background {
  background-color: rgba(225, 218, 252, 0.86);
  border-radius: 10px;
}

.flex-vertical-align {
  display: flex;
  align-items: center;
}

.go-to-next-button {
  width: 100%;
  height: 30px;
  border: none !important;
  border-radius: 10px;
  background-color: dodgerblue;
  color: white;
}

.ctc-payment-button {
  background-color: dodgerblue;
  color: white;
  border-radius: 10px;
  width: 100%;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-owner-name-text {
  font-size: 1rem;
}

.image-card-details {
  position: absolute;
  margin-top: 9%;
  font-weight: bold;
  font-size: 1.2rem;
}
.d-font-size {
  font-size: 1.5rem !important;
}
@media only screen and (max-width: 1300px) {
  .d-font-size {
    font-size: 1rem !important;
  }
}

@media only screen and (max-width: 990px) {
  .image-card-details {
    font-size: 2.5rem !important;
    margin-top: 30% !important;
  }

  .card-owner-name-text {
    font-size: 2rem;
  }
}

@media only screen and (max-width: 449px) {
  .image-card-details {
    font-size: 1.5rem !important;
    margin-top: 30% !important;
  }

  .card-owner-name-text {
    font-size: 1.2rem;
  }
}

@media only screen and (max-width: 600px) and (min-width: 450px) {
  .image-card-details {
    font-size: 2.5rem !important;
    margin-top: 30% !important;
  }

  .card-owner-name-text {
    font-size: 2rem;
  }
}
</style>
